var map = {
	"./admin/__tests__/state/ducks/user/operations": 609,
	"./admin/__tests__/state/ducks/user/operations.js": 609,
	"./admin/__tests__/view/pages/users": 613,
	"./admin/__tests__/view/pages/users.js": 613,
	"./admin/admin": 728,
	"./admin/admin.js": 728,
	"./admin/state/ducks": 350,
	"./admin/state/ducks/": 350,
	"./admin/state/ducks/group": 99,
	"./admin/state/ducks/group/": 99,
	"./admin/state/ducks/group/components": 351,
	"./admin/state/ducks/group/components.js": 351,
	"./admin/state/ducks/group/index": 99,
	"./admin/state/ducks/group/index.js": 99,
	"./admin/state/ducks/group/operations": 244,
	"./admin/state/ducks/group/operations.js": 244,
	"./admin/state/ducks/index": 350,
	"./admin/state/ducks/index.js": 350,
	"./admin/state/ducks/oauth2/accessToken": 118,
	"./admin/state/ducks/oauth2/accessToken/": 118,
	"./admin/state/ducks/oauth2/accessToken/index": 118,
	"./admin/state/ducks/oauth2/accessToken/index.js": 118,
	"./admin/state/ducks/oauth2/accessToken/operations": 352,
	"./admin/state/ducks/oauth2/accessToken/operations.js": 352,
	"./admin/state/ducks/oauth2/authCode": 134,
	"./admin/state/ducks/oauth2/authCode/": 134,
	"./admin/state/ducks/oauth2/authCode/components": 730,
	"./admin/state/ducks/oauth2/authCode/components.js": 730,
	"./admin/state/ducks/oauth2/authCode/index": 134,
	"./admin/state/ducks/oauth2/authCode/index.js": 134,
	"./admin/state/ducks/oauth2/authCode/operations": 245,
	"./admin/state/ducks/oauth2/authCode/operations.js": 245,
	"./admin/state/ducks/oauth2/client": 85,
	"./admin/state/ducks/oauth2/client/": 85,
	"./admin/state/ducks/oauth2/client/components": 353,
	"./admin/state/ducks/oauth2/client/components.js": 353,
	"./admin/state/ducks/oauth2/client/index": 85,
	"./admin/state/ducks/oauth2/client/index.js": 85,
	"./admin/state/ducks/oauth2/client/operations": 246,
	"./admin/state/ducks/oauth2/client/operations.js": 246,
	"./admin/state/ducks/oauth2/refreshToken": 135,
	"./admin/state/ducks/oauth2/refreshToken/": 135,
	"./admin/state/ducks/oauth2/refreshToken/index": 135,
	"./admin/state/ducks/oauth2/refreshToken/index.js": 135,
	"./admin/state/ducks/oauth2/refreshToken/operations": 354,
	"./admin/state/ducks/oauth2/refreshToken/operations.js": 354,
	"./admin/state/ducks/oauth2/scope": 136,
	"./admin/state/ducks/oauth2/scope/": 136,
	"./admin/state/ducks/oauth2/scope/index": 136,
	"./admin/state/ducks/oauth2/scope/index.js": 136,
	"./admin/state/ducks/oauth2/scope/operations": 355,
	"./admin/state/ducks/oauth2/scope/operations.js": 355,
	"./admin/state/ducks/pm/process": 208,
	"./admin/state/ducks/pm/process/": 208,
	"./admin/state/ducks/pm/process/index": 208,
	"./admin/state/ducks/pm/process/index.js": 208,
	"./admin/state/ducks/pm/process/operations": 356,
	"./admin/state/ducks/pm/process/operations.js": 356,
	"./admin/state/ducks/pm/task": 148,
	"./admin/state/ducks/pm/task/": 148,
	"./admin/state/ducks/pm/task/components": 357,
	"./admin/state/ducks/pm/task/components.js": 357,
	"./admin/state/ducks/pm/task/index": 148,
	"./admin/state/ducks/pm/task/index.js": 148,
	"./admin/state/ducks/pm/task/operations": 247,
	"./admin/state/ducks/pm/task/operations.js": 247,
	"./admin/state/ducks/pm/ws": 243,
	"./admin/state/ducks/pm/ws/": 243,
	"./admin/state/ducks/pm/ws/index": 243,
	"./admin/state/ducks/pm/ws/index.js": 243,
	"./admin/state/ducks/pm/ws/operations": 349,
	"./admin/state/ducks/pm/ws/operations.js": 349,
	"./admin/state/ducks/realm": 93,
	"./admin/state/ducks/realm/": 93,
	"./admin/state/ducks/realm/components": 345,
	"./admin/state/ducks/realm/components.js": 345,
	"./admin/state/ducks/realm/index": 93,
	"./admin/state/ducks/realm/index.js": 93,
	"./admin/state/ducks/realm/operations": 240,
	"./admin/state/ducks/realm/operations.js": 240,
	"./admin/state/ducks/resource": 209,
	"./admin/state/ducks/resource/": 209,
	"./admin/state/ducks/resource/index": 209,
	"./admin/state/ducks/resource/index.js": 209,
	"./admin/state/ducks/resource/operations": 358,
	"./admin/state/ducks/resource/operations.js": 358,
	"./admin/state/ducks/role": 86,
	"./admin/state/ducks/role/": 86,
	"./admin/state/ducks/role/components": 344,
	"./admin/state/ducks/role/components.js": 344,
	"./admin/state/ducks/role/index": 86,
	"./admin/state/ducks/role/index.js": 86,
	"./admin/state/ducks/role/operations": 239,
	"./admin/state/ducks/role/operations.js": 239,
	"./admin/state/ducks/user": 49,
	"./admin/state/ducks/user/": 49,
	"./admin/state/ducks/user/components": 318,
	"./admin/state/ducks/user/components.js": 318,
	"./admin/state/ducks/user/index": 49,
	"./admin/state/ducks/user/index.js": 49,
	"./admin/state/ducks/user/operations": 238,
	"./admin/state/ducks/user/operations.js": 238,
	"./admin/state/middleware": 242,
	"./admin/state/middleware/": 242,
	"./admin/state/middleware/index": 242,
	"./admin/state/middleware/index.js": 242,
	"./admin/state/middleware/pm/ws": 348,
	"./admin/state/middleware/pm/ws.js": 348,
	"./admin/views/pages/group": 488,
	"./admin/views/pages/group.js": 488,
	"./admin/views/pages/groups": 489,
	"./admin/views/pages/groups.js": 489,
	"./admin/views/pages/oauth2/accessToken": 490,
	"./admin/views/pages/oauth2/accessToken.js": 490,
	"./admin/views/pages/oauth2/accessTokens": 491,
	"./admin/views/pages/oauth2/accessTokens.js": 491,
	"./admin/views/pages/oauth2/authCode": 492,
	"./admin/views/pages/oauth2/authCode.js": 492,
	"./admin/views/pages/oauth2/authCodes": 493,
	"./admin/views/pages/oauth2/authCodes.js": 493,
	"./admin/views/pages/oauth2/client": 494,
	"./admin/views/pages/oauth2/client.js": 494,
	"./admin/views/pages/oauth2/clients": 495,
	"./admin/views/pages/oauth2/clients.js": 495,
	"./admin/views/pages/oauth2/refreshToken": 496,
	"./admin/views/pages/oauth2/refreshToken.js": 496,
	"./admin/views/pages/oauth2/refreshTokens": 497,
	"./admin/views/pages/oauth2/refreshTokens.js": 497,
	"./admin/views/pages/oauth2/scope": 498,
	"./admin/views/pages/oauth2/scope.js": 498,
	"./admin/views/pages/oauth2/scopes": 499,
	"./admin/views/pages/oauth2/scopes.js": 499,
	"./admin/views/pages/pm/processes": 500,
	"./admin/views/pages/pm/processes.js": 500,
	"./admin/views/pages/pm/task": 501,
	"./admin/views/pages/pm/task.js": 501,
	"./admin/views/pages/pm/tasks": 502,
	"./admin/views/pages/pm/tasks.js": 502,
	"./admin/views/pages/realm": 503,
	"./admin/views/pages/realm.js": 503,
	"./admin/views/pages/realms": 504,
	"./admin/views/pages/realms.js": 504,
	"./admin/views/pages/role": 505,
	"./admin/views/pages/role.js": 505,
	"./admin/views/pages/role/acl": 369,
	"./admin/views/pages/role/acl.js": 369,
	"./admin/views/pages/role/actions": 370,
	"./admin/views/pages/role/actions.js": 370,
	"./admin/views/pages/role/module": 252,
	"./admin/views/pages/role/module.js": 252,
	"./admin/views/pages/role/operations": 733,
	"./admin/views/pages/role/operations.js": 733,
	"./admin/views/pages/role/resource": 734,
	"./admin/views/pages/role/resource.js": 734,
	"./admin/views/pages/roles": 506,
	"./admin/views/pages/roles.js": 506,
	"./admin/views/pages/user": 507,
	"./admin/views/pages/user.js": 507,
	"./admin/views/pages/user/general": 371,
	"./admin/views/pages/user/general.js": 371,
	"./admin/views/pages/user/security": 372,
	"./admin/views/pages/user/security.js": 372,
	"./admin/views/pages/users": 294,
	"./admin/views/pages/users.js": 294,
	"./coin/coin": 735,
	"./coin/coin.js": 735,
	"./coin/const/order": 71,
	"./coin/const/order.js": 71,
	"./coin/const/transaction": 192,
	"./coin/const/transaction.js": 192,
	"./coin/state/ducks/balance": 172,
	"./coin/state/ducks/balance/": 172,
	"./coin/state/ducks/balance/index": 172,
	"./coin/state/ducks/balance/index.js": 172,
	"./coin/state/ducks/balance/operations": 359,
	"./coin/state/ducks/balance/operations.js": 359,
	"./coin/state/ducks/currency": 80,
	"./coin/state/ducks/currency/": 80,
	"./coin/state/ducks/currency/components": 360,
	"./coin/state/ducks/currency/components.js": 360,
	"./coin/state/ducks/currency/index": 80,
	"./coin/state/ducks/currency/index.js": 80,
	"./coin/state/ducks/currency/operations": 248,
	"./coin/state/ducks/currency/operations.js": 248,
	"./coin/state/ducks/dashboard": 210,
	"./coin/state/ducks/dashboard/": 210,
	"./coin/state/ducks/dashboard/index": 210,
	"./coin/state/ducks/dashboard/index.js": 210,
	"./coin/state/ducks/dashboard/operations": 361,
	"./coin/state/ducks/dashboard/operations.js": 361,
	"./coin/state/ducks/exchange": 106,
	"./coin/state/ducks/exchange/": 106,
	"./coin/state/ducks/exchange/components": 362,
	"./coin/state/ducks/exchange/components.js": 362,
	"./coin/state/ducks/exchange/index": 106,
	"./coin/state/ducks/exchange/index.js": 106,
	"./coin/state/ducks/exchange/operations": 249,
	"./coin/state/ducks/exchange/operations.js": 249,
	"./coin/state/ducks/order": 87,
	"./coin/state/ducks/order/": 87,
	"./coin/state/ducks/order/index": 87,
	"./coin/state/ducks/order/index.js": 87,
	"./coin/state/ducks/order/operations": 363,
	"./coin/state/ducks/order/operations.js": 363,
	"./coin/state/ducks/transaction": 149,
	"./coin/state/ducks/transaction/": 149,
	"./coin/state/ducks/transaction/index": 149,
	"./coin/state/ducks/transaction/index.js": 149,
	"./coin/state/ducks/transaction/operations": 364,
	"./coin/state/ducks/transaction/operations.js": 364,
	"./coin/state/ducks/user": 116,
	"./coin/state/ducks/user/": 116,
	"./coin/state/ducks/user/components": 365,
	"./coin/state/ducks/user/components.js": 365,
	"./coin/state/ducks/user/index": 116,
	"./coin/state/ducks/user/index.js": 116,
	"./coin/state/ducks/user/operations": 250,
	"./coin/state/ducks/user/operations.js": 250,
	"./coin/todo.txt": 1125,
	"./coin/utils": 28,
	"./coin/utils.js": 28,
	"./coin/views/pages/admin": 508,
	"./coin/views/pages/admin.js": 508,
	"./coin/views/pages/balance": 509,
	"./coin/views/pages/balance.js": 509,
	"./coin/views/pages/balance/currency": 510,
	"./coin/views/pages/balance/currency.js": 510,
	"./coin/views/pages/balance/currency/data": 374,
	"./coin/views/pages/balance/currency/data.js": 374,
	"./coin/views/pages/balance/currency/data/exchange": 375,
	"./coin/views/pages/balance/currency/data/exchange.js": 375,
	"./coin/views/pages/balance/currency/data/user": 376,
	"./coin/views/pages/balance/currency/data/user.js": 376,
	"./coin/views/pages/balance/currency/info": 373,
	"./coin/views/pages/balance/currency/info.js": 373,
	"./coin/views/pages/currencies": 511,
	"./coin/views/pages/currencies.js": 511,
	"./coin/views/pages/dashboard": 512,
	"./coin/views/pages/dashboard.js": 512,
	"./coin/views/pages/dashboard/dailyChart": 377,
	"./coin/views/pages/dashboard/dailyChart.js": 377,
	"./coin/views/pages/order": 518,
	"./coin/views/pages/order.js": 518,
	"./coin/views/pages/order/view": 385,
	"./coin/views/pages/order/view.js": 385,
	"./coin/views/pages/order/view/transactions": 387,
	"./coin/views/pages/order/view/transactions.js": 387,
	"./coin/views/pages/order/view/users": 386,
	"./coin/views/pages/order/view/users.js": 386,
	"./coin/views/pages/order/wizard": 378,
	"./coin/views/pages/order/wizard.js": 378,
	"./coin/views/pages/order/wizard/context": 132,
	"./coin/views/pages/order/wizard/context.js": 132,
	"./coin/views/pages/order/wizard/finish_step": 384,
	"./coin/views/pages/order/wizard/finish_step.js": 384,
	"./coin/views/pages/order/wizard/general_step": 379,
	"./coin/views/pages/order/wizard/general_step.js": 379,
	"./coin/views/pages/order/wizard/orderUsers/add": 382,
	"./coin/views/pages/order/wizard/orderUsers/add.js": 382,
	"./coin/views/pages/order/wizard/orderUsers/fill": 383,
	"./coin/views/pages/order/wizard/orderUsers/fill.js": 383,
	"./coin/views/pages/order/wizard/orderUsers/table": 381,
	"./coin/views/pages/order/wizard/orderUsers/table.js": 381,
	"./coin/views/pages/order/wizard/users_step": 380,
	"./coin/views/pages/order/wizard/users_step.js": 380,
	"./coin/views/pages/orders": 519,
	"./coin/views/pages/orders.js": 519,
	"./coin/views/pages/transactions": 520,
	"./coin/views/pages/transactions.js": 520,
	"./example/__tests__/state/ducks/ping/operations": 742,
	"./example/__tests__/state/ducks/ping/operations.js": 742,
	"./example/example": 743,
	"./example/example.js": 743,
	"./example/state/ducks/ping": 147,
	"./example/state/ducks/ping/": 147,
	"./example/state/ducks/ping/index": 147,
	"./example/state/ducks/ping/index.js": 147,
	"./example/state/ducks/ping/operations": 367,
	"./example/state/ducks/ping/operations.js": 367,
	"./example/views/pages/auth": 521,
	"./example/views/pages/auth.js": 521,
	"./example/views/pages/auth/control": 389,
	"./example/views/pages/auth/control.js": 389,
	"./example/views/pages/auth/login": 388,
	"./example/views/pages/auth/login.js": 388,
	"./example/views/pages/auth/state": 390,
	"./example/views/pages/auth/state.js": 390,
	"./example/views/pages/ping": 522,
	"./example/views/pages/ping.js": 522,
	"./example/views/pages/ping/multiple": 299,
	"./example/views/pages/ping/multiple.js": 299,
	"./example/views/pages/ping/single": 391,
	"./example/views/pages/ping/single.js": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 845;